export default [
  {
    header: 'Игры',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Список игр',
    route: 'games',
    icon: 'ListIcon',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Создать игру',
    route: 'random-game-create',
    icon: 'PlusSquareIcon',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Построитель игр',
    route: 'game-builder-list',
    icon: 'ToolIcon',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Игровые недели',
    route: 'game-weeks',
    icon: 'CalendarIcon',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Telegram-синхронизация',
    route: 'telegram-sync',
    icon: 'SendIcon',
    resource: 'games',
    action: 'view',
  },
  {
    // Подзаголовок на том же resource, что и «Игры»: делит длинную секцию
    // визуально, но появляется и исчезает вместе с ней.
    header: 'Planfix',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Игры Planfix',
    route: 'planfix-games',
    icon: 'ClipboardIcon',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Планфикс Пакеты',
    route: 'planfix-packs',
    icon: 'ArchiveIcon',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Импорт расписания',
    route: 'schedule-import',
    icon: 'UploadIcon',
    resource: 'games',
    action: 'view',
  },
]
